module.exports = __webpack_public_path__ + "static/img/064_TO8_1624.c04565c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/064_TO8_1624.jpg
// module id = p8Ce
// module chunks = 0